// Modules
import React from 'react';

// Material-ui
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import Dialog, { type DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent, { type DialogContentProps } from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';

// Helpers
// Components
// Common components

export const StyledDialog = styled(({ children, ...props }: DialogProps) => (
  <Dialog {...props}>{children}</Dialog>
))(() => ({}));

export const StyledDialogHeader = styled(DialogTitle)({
  padding: '1rem 2rem',
  fontSize: '0.875rem',
});

export const StyledDialogContent = styled(({ children, ...props }: DialogContentProps) => (
  <DialogContent dividers {...props}>
    {children}
  </DialogContent>
))({
  padding: '1rem 2rem',
  fontSize: '0.875rem',
});

export const StyledDialogContentFull = styled(({ children, ...props }: DialogContentProps) => (
  <DialogContent dividers {...props}>
    {children}
  </DialogContent>
))({
  padding: '0',
});

export const StyledDialogFooter = styled(DialogActions)({
  padding: '1rem 2rem',
  justifyContent: 'flex-end',
  fontSize: '0.875rem',
});

export const StyledDialogFooterAlignRight = styled(DialogActions)({
  padding: '1rem 2rem',
  justifyContent: 'flex-end',
  fontSize: '0.875rem',
});

export const StyledDialogTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: '0.875rem',
  marginRight: '1rem',
});

export const StyledDialogSubtitle = styled(Typography)({
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  fontWeight: 700,
}) as typeof Typography;

export const StyledDialogDescription = styled(Typography)({
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
}) as typeof Typography;

export const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  cursor: 'pointer',
  marginLeft: 'auto',
  color: theme.mainColor,
}));

export const StyledCloseButton = styled(({ children, ...props }: IconButtonProps) => (
  <IconButton {...props}>
    <CloseIcon />
  </IconButton>
))(({ theme }) => ({
  cursor: 'pointer',
  marginLeft: 'auto',
  color: theme.mainColor,
}));
